import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { TripDetails } from "redmond";
import { IStoreState } from "../../../../../../reducers/types";

import {
  isOutgoingMultiTicketSelector,
  isReturnMultiTicketSelector,
} from "../../../../../flight-shop/reducer";
import { getFlightTripIdentity } from "../../../../../flight-shop/utils/useFlightTripIdentity";

import { finalizePackage } from "../../../../actions/actions";
import { ReviewFlightDetails } from "./component";

const mapStateToProps = (state: IStoreState) => {
  const { tripDetails } = getFlightTripIdentity(state);

  return {
    // This component is only ever rendered by ReviewFlightItinerary, which already gates
    // on `tripDetails?.slices` before mounting it — so tripDetails is guaranteed defined here.
    tripDetails: tripDetails as TripDetails,

    isMultiTicket:
      isOutgoingMultiTicketSelector(state) ||
      isReturnMultiTicketSelector(state),
  };
};

export const mapDispatchToProps = {
  finalizePackage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type ReviewFlightDetailsConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedReviewFlightDetails = withRouter(
  connector(ReviewFlightDetails)
);
